module.exports = __webpack_public_path__ + "static/img/data2-img.a0fa69d9.png";